import React from 'react';
import { observer } from 'mobx-react';
import { Box, Callout } from 'core/components';
import { FiInfo } from 'react-icons/fi';

export default observer(({ boxProps, title, description, intent = 'primary', icon = FiInfo }) => (
  <Box {...boxProps}>
    <Callout title={title} intent={intent} icon={icon} pl="29px">
      {description}
    </Callout>
  </Box>
));
